import { store } from "@/store";

export const tripStore = {
  namespaced: true,
  state: () => ({
    all: "",
    lastTen: "",
    allTripByCars: [],
    type: "trip",
    last: "",
    commonDeparture: {},
    commonArrival: {},
    distance: "",
    lastTrip: "",
    actionSuccessMsg: "",
    actionErrorMsg: ""
  }),
  getters: {
    getCommonVehicle: state => {
      let sortedDeparture = Object.fromEntries(
        Object.entries(state.commonDeparture).sort(([, a], [, b]) => a - b)
      );
      return Object.keys(sortedDeparture).pop();
    },
    getCommonDeparture: state => {
      let sortedDeparture = Object.fromEntries(
        Object.entries(state.commonDeparture).sort(([, a], [, b]) => a - b)
      );
      return Object.keys(sortedDeparture).pop();
    },

    getFrequentArrival: state => {
      return Object.keys(state.commonArrival).pop();
    },
    getLastestTrip: state => {
      return state.allTripByCars[0];
    }
  },
  mutations: {
    //save records
    save(state, formData) {
      store.state.database.put(formData, function callback(err) {
        if (err) {
          state.actionErrorMsg = "failedSave";
          //console.log("saving failed");
          return false;
        }
        state.actionSuccessMsg = "successSave";
      });
    },
    getAllTrips(state) {
      store.state.database
        .find({
          selector: { type: state.type, _id: { $exists: true }, status: 0 },
          sort: ["_id"]
        })
        .then(result => {
          state.all = result.docs.reverse();
        })
        .catch(function(err) {
          console.log(err);
        });
    },

    //delete record from Pouch
    markForDeletion(state, trip) {
      store.commit("trip/save", trip);
    },
    getAllTripsByCars(state, car) {
      let car_id = car ? car : store.state.car.defaultVehicle._id;
      store.state.database
        .find({
          selector: {
            type: state.type,
            _id: { $exists: true },
            vehicle_pouch_id: car_id,
            status: 0
          },
          sort: ["_id"]
        })
        .then(result => {
          state.allTripByCars = result.docs.reverse();
          store.commit("trip/getMostCommonStartingPoint", state.allTripByCars);
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getMostCommonStartingPoint(state, tripsBycar = null) {
      var common = {};
      let trips = !tripsBycar ? state.all : state.allTripByCars;
      trips.map(trip => {
        common[trip.departure_location_id] =
          trip.departure_location_id in common
            ? parseInt(common[trip.departure_location_id]) + 1
            : 0;
      }, "");
      state.commonDeparture = common;
    },

    getMostCommonEndingPoint(state, payload) {
      var commonTripCounter = {};
      try {
        // let trips = (!payload[1]) ? state.all : state.allTripByCars;
        state.allTripByCars.map(trip => {
          //    commonArrivalCounter[trip.arrivalLocationId] = (trip.arrivalLocationId in commonArrivalCounter) ? parseInt(commonArrivalCounter[trip.arrivalLocationId]) + 1 : 1;
          if (trip.departure_location_id == payload[0]) {
            commonTripCounter[trip.arrival_location_id] =
              trip.arrival_location_id in commonTripCounter
                ? parseInt(commonTripCounter[trip.arrival_location_id]) + 1
                : 1;
          }
        }, "");

        state.commonArrival = Object.fromEntries(
          Object.entries(commonTripCounter).sort(([, a], [, b]) => a - b)
        );

        //guess the distance
        store.commit("trip/getDistance", [
          store.getters["trip/getCommonDeparture"],
          store.getters["trip/getFrequentArrival"]
        ]);
      } catch (e) {
        commonTripCounter = {};
      }
    },
    resetValue(state) {
      state.commonArrival = "";
      state.commonDeparture = "";
      state.all = "";
    },

    clearMes(state) {
      setTimeout(() => {
        state.actionSuccessMsg = "";
        state.actionErrorMsg = "";
      }, 2000);
      return true;
    },
    getDistance(state, points) {
      for (let trip of state.allTripByCars) {
        if (
          trip.departure_location_id === points[0] &&
          trip.arrival_location_id === points[1]
        ) {
          state.distance =
            parseInt(trip.final_odometer) - parseInt(trip.initial_odometer);
          break;
        }
      }
    }
  },
  actions: {
    getTripsAction({ commit }) {
      commit("getAllTrips");
    },
    getTripsByCarAction({ commit }, car_id) {
      commit("getAllTripsByCars", car_id);
    },
    getFrequentArrivalAction({ commit }, departure, car) {
      commit("getMostCommonEndingPoint", [departure, car]);
    },
    getDistanceAction({ commit }, points) {
      commit("getDistance", points);
    }
  }
};
